// extracted by mini-css-extract-plugin
module.exports = {"heading":"CustomBrandingModal_heading__28Rz5","color_select":"CustomBrandingModal_color_select__1h40B"};